export const USER_INFO = 'modify/modifyUserInfo';
